import React, { useState, forwardRef } from "react";
import * as _f_ from "@Funciones/funciones";

export const InputModerno = ({
  texto,
  tipo = "text",
  name,
  estilos = {},
  ...props
}) => {
  const [mostrarPassword, setMostrarPassword] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [valor, setValor] = useState("");

  const esPassword = tipo === "password";
  const esFecha = tipo === "date";

  const manejarCambio = (e) => {
    setValor(e.target.value);
    if (props.onChange) props.onChange(e);
  };

  return (
    <div className="InputModerno-grupo">
      <input
        name={name}
        className={`InputModerno-campo ${valor || isFocused ? "es-activo" : ""}`}
        type={esPassword ? (mostrarPassword ? "text" : "password") : tipo}
        placeholder=" "
        onFocus={() => setIsFocused(true)}
        onBlur={(e) => {
          setIsFocused(false);
          setValor(e.target.value);
        }}
        style={_f_.estilosObjetoVariablesCSS(estilos)}
        onChange={manejarCambio}
        {...props}
      />

      <label className="InputModerno-etiqueta">{texto}</label>

      {esPassword && (
        <button
          type="button"
          className="InputModerno-icono"
          onClick={() => setMostrarPassword(!mostrarPassword)}
        >
          {mostrarPassword ? "🔓" : "🔒"}
        </button>
      )}

      {esFecha && !valor && !isFocused && (
        <span className="InputModerno-icono" style={{ pointerEvents: "none" }}>
          📅
        </span>
      )}
    </div>
  );
};
export default InputModerno;

export const Input2 = forwardRef(
  ({ texto, tipo = "text", name, estilos = {}, ...props }, ref) => {
    return (
      <div className="Input2" style={_f_.estilosObjetoVariablesCSS(estilos)}>
        <input
          type={tipo}
          name={name}
          id={`Input2-${name}`}
          className="Input2-campo"
          placeholder=" "
          ref={ref}
          {...props}
        />
        <label className="Input2-etiqueta">{texto}</label>
      </div>
    );
  },
);

export const Input3 = forwardRef(
  ({ texto, tipo = "text", name, estilos = {}, ...props }, ref) => {
    return (
      <div className="Input3" style={_f_.estilosObjetoVariablesCSS(estilos)}>
        <input
          type={tipo}
          name={name}
          id={`Input3-${name}`}
          className="Input3-campo"
          placeholder=" "
          ref={ref}
          {...props}
        />
        <label htmlFor={`Input3-${name}`} className="Input3-etiqueta">
          {texto}
        </label>
      </div>
    );
  },
);

export const Input4 = forwardRef(
  ({ texto, tipo = "text", name, estilos = {}, ...props }, ref) => {
    return (
      <div className="Input4" style={_f_.estilosObjetoVariablesCSS(estilos)}>
        <input
          
          type={tipo}
          name={name}
          id={`Input4-${name}`}
          className="Input4-campo"
          placeholder=" "
          ref={ref}
          {...props}
        />
        <label htmlFor={`Input4-${name}`} className="Input4-etiqueta">
          {texto}
        </label>
      </div>
    );
  },
);

export const Input5 = forwardRef(
  ({ texto = "", tipo = "text", name, estilos = {}, inputkey, ...props }, ref) => {
    return (
      <div className="Input5" style={_f_.estilosObjetoVariablesCSS(estilos)}>
        <input
          key={inputkey}
          type={tipo}
          name={name}
          id={`Input5-${name}`}
          className="Input5-campo"
          placeholder={texto}
          ref={ref}
          {...props}
        />
      </div>
    );
  },
);

export const Input6 = forwardRef(
  ({ tipo = "text", name, estilos = {}, ...props }, ref) => {
    return (
      <div className="Input6" style={_f_.estilosObjetoVariablesCSS(estilos)}>
        <input
          type={tipo}
          name={name}
          id={`Input6-${name}`}
          className="Input6-campo"
          ref={ref}
          {...props}
        />
      </div>
    );
  },
);


export const InputDate = forwardRef(
  ({ texto, tipo = "date", name, estilos = {}, ...props }, ref) => {
    return (
      <div className="Input4" style={_f_.estilosObjetoVariablesCSS(estilos)}>
        <input
          
          type={"date"}
          name={name}
          id={`Input4-${name}`}
          className="Input4-campo"
          placeholder=" "
          ref={ref}
          {...props}
        />
        <label htmlFor={`Input4-${name}`} className="Input4-etiqueta">
          {texto}
        </label>
      </div>
    );
  },
);